/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M19,12.3h1.7c0.5,0,0.7-0.6,0.3-0.9l-8.4-7.5c-0.4-0.3-1-0.3-1.3,0L3,11.5c-0.3,0.3-0.1,0.9,0.3,0.9H5v3H4 c-0.6,0-1,0.5-1,1s0.4,1,1,1h1v2c0,0.5,0.5,1,1,1s1-0.5,1-1v-2h4v2c0,0.5,0.4,1,1,1s1-0.5,1-1v-2h4v2c0,0.5,0.4,1,1,1 c0.5,0,1-0.5,1-1v-2h1c0.5,0,1-0.5,1-1c0-0.6-0.5-1-1-1h-1V12.3z M7,15.3v-4.8l4-3.6v8.4C11,15.3,7,15.3,7,15.3z M13,15.3V6.9l4,3.6 v4.8H13z"
}), 'CategoryCJ', {
  viewBox: '0 0 24 24'
});